import React from 'react';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeOrderFormView1FrameView({
  completedCount,
  priceInfo,
  children,
} : {
  completedCount: number,
  priceInfo: KaraokeOrderPriceInfo,
  children: React.ReactNode,
}) {

  React.useEffect(() => {
    // スムーズスクロール
    const headerHight = 0;
    $('article a[href^="#"]').click(function() {
      const speed = 400;
      const href = $(this).attr('href');
      const target = $(href === '#' || href === '' ? 'html' : href);
      const position = target.offset().top - headerHight;
      $('body,html').animate({
        scrollTop: position,
      }, speed, 'swing');
      return false;
    });

    // スクロールアニメーション
    $('.fadein1,.fadein2,.fadein3,.fadein4,.fadein5,.fadein6,.fadein7,.fade_list li,.logo_anime,article').on(
      'inview',
      function (event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
          $(this).stop().addClass('is-show');
        }
      },
    );

    gsap.config({
      nullTargetWarn: false,
    });

    // タイトルアニメーション
    function setupSplits() {
      const quotes = document.querySelectorAll('.js-title');
      quotes.forEach((quote) => {
        // Reset if needed
        if (quote.anim) {
          quote.anim.progress(1).kill();
          quote.split.revert();
        }

        // eslint-disable-next-line no-param-reassign
        quote.split = new SplitText(quote, {
          type: 'lines,words,chars',
          linesClass: 'split-line',
        });

        // Set up the anim
        // eslint-disable-next-line no-param-reassign
        quote.anim = gsap.from(quote.split.chars, {
          scrollTrigger: {
            trigger: quote,
            start: 'top bottom-=10%',
            once: true,
          },
          duration: 0.5,
          ease: 'circ.out',
          y: 90,
          stagger: 0.004,
        });
      });
    }

    ScrollTrigger.addEventListener('refresh', setupSplits);
    setupSplits();

    // テキスト横スクロール
    gsap.to(document.querySelector('.side-scroll-list'), {
      xPercent: -100.7,
      ease: 'none',
      scrollTrigger: {
        trigger: '.side-scroll',
        start: 'top top', // 要素の上端（top）が、ビューポートの上端（top）にきた時
        scrub: 3,
      },
    });

    gsap.to(document.querySelector('.side-scroll-list-reverse'), {
      xPercent: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: '.side-scroll',
        start: 'top top', // 要素の上端（top）が、ビューポートの上端（top）にきた時
        scrub: 3,
      },
    });

    // マウスストーカー
    const stalker = document.createElement('div');
    const linkElems = document.querySelectorAll('a:not(.no_stick_), button, .qa__item');
    TweenMax.set(stalker, {
      scale: 0.2,
    });
    stalker.classList.add('stalker');
    document.body.appendChild(stalker);
    document.addEventListener('mousemove', (e) => {
      TweenMax.to(stalker, 0.3, {
        x: e.clientX,
        y: e.clientY,
      });
    });
    linkElems.forEach((ele) => {
      ele.addEventListener('mouseover', () => {
        stalker.classList.add('is-active');
        TweenMax.to(stalker, 0.3, {
          scale: 1.2,
        });
      });
      ele.addEventListener('mouseleave', () => {
        stalker.classList.remove('is-active');
        TweenMax.to(stalker, 0.3, {
          scale: 0.2,
        });
      });
    });

  // オーディオエレメントとボタンエレメントを取得
const audioPlayers = document.querySelectorAll('.audioPlayer');
const toggleButtons = document.querySelectorAll('.toggleButton');

// 各オーディオプレイヤーごとにイベントリスナーを設定
audioPlayers.forEach((audioPlayer, index) => {
    let isPlaying = false;

    toggleButtons[index].addEventListener('click', function() {
        if (isPlaying) {
            audioPlayer.pause();  // オーディオを停止
            toggleButtons[index].src = '/img/karaoke_service/play.svg';
            isPlaying = false;  // 再生状態を更新
            audioPlayer.currentTime = 0; // 再生位置をリセット
        } else {
            audioPlayer.play();  // オーディオを再生
            toggleButtons[index].src = '/img/karaoke_service/stop.svg';
            isPlaying = true;  // 再生状態を更新
        }
    });
});

    // KVテキストモーション
    // an array of all the divs that wrap each character
    const tl = gsap.timeline();
    const mySplitText = new SplitText('#quote', {
      type: 'words,chars',
    });
    const { chars } = mySplitText;

    gsap.set('#quote', {
      perspective: 400,
    });

    console.log(chars);

    tl.from(chars, {
      duration: 0.8,
      opacity: 0,
      scale: 0,
      y: 80,
      rotationX: 180,
      transformOrigin: '0% 50% -50',
      ease: 'back',
      stagger: 0.01,
    });

    $(window).scroll(() => {
      const element = $('.add_contents');
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();
      const elementTop = element.offset().top;
      const elementHeight = element.outerHeight();

      if (scroll > elementTop - windowHeight + elementHeight) {
        $('.float_link').addClass('is-active');
      } else {
        $('.float_link').removeClass('is-active');
      }
    });
  }, []);

  return (
    <>
      <article>
        <section className="c-kv">
          <div className="c-kv__header">
            <h1 className="main">
              <span className="main__ttl">あなたの曲を、JOYSOUNDに。</span>
            </h1>
            <a href="#c-form" className="c-bt_bk bt_kv">今すぐ申し込む</a>
          </div>
          <img src="/img/karaoke_service/stylish/kv.png" className="pc" alt="" />
          <img src="/img/karaoke_service/stylish/kv_sp.png" className="sp" alt="" />
        </section>
        <section className="c-about">
          <div className="side-scroll-list font-large">
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
          </div>
          <div className="inner">
            <h2 className="catch js-title">
              あなたのオリジナル曲が
              <br />
              全国のカラオケ店で
              <br />
              歌えるようになります。
            </h2>
          </div>
          <div className="add_counter">
            <div className="add_counter__inner">
              <div className="add_counter_box">
                <ul>
                  <li>
                    <h3>
                      配信
                      <br />
                      実績
                    </h3>
                  </li>
                  <li>
                    <span>
                      <b>{completedCount}</b>
                      曲
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side-scroll-list-reverse font-small">
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
            KARAOKE DISTRIBUTION&nbsp;&nbsp;
          </div>
        </section>
        <div className="bg__illust">
          <section className="c-destination">
            <h2 className="c-title">
              <span className="c-title__en js-title">
                DELIVERY
                <br />
                DESTINATION
              </span>
              <span className="c-title__jp js-title">配信先</span>
            </h2>
            <div className="inner">
              <ul className="c-box fade_list">
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_x1.png" alt="" /></li>
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_maxgo.png" alt="" /></li>
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_max2.png" alt="" /></li>
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_max.png" alt="" /></li>
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_f1.png" alt="" /></li>
                <li className="c-box__item"><img src="/img/karaoke_service/joysound_hibiki2.png" alt="" /></li>
              </ul>
            </div>
          </section>

          <section className="c-flow">
            <h2 className="c-title">
              <span className="c-title__en-illust js-title">FLOW</span>
              <span className="c-title__jp js-title">ご利用の流れ</span>
            </h2>
            <div className="inner">
              <ul className="flow-box fade_list">
                <li className="flow-box__item">
                  <span className="number circle">1</span>
                  <img
                    src="/img/karaoke_service/stylish/01_icon.svg"
                    alt=""
                  />
                  <span className="text">申し込み</span>
                </li>
                <li className="flow-box__item">
                  <span className="number">2</span>
                  <img
                    src="/img/karaoke_service/stylish/02_icon.svg"
                    alt=""
                  />
                  <span className="text">お支払い</span>
                </li>
                <li className="flow-box__item">
                  <span className="number">3</span>
                  <img
                    src="/img/karaoke_service/stylish/03_icon.svg"
                    alt=""
                  />
                  <span className="text">素材提出</span>
                </li>
                <li className="flow-box__item">
                  <span className="number no-style"></span>
                  <img
                    src="/img/karaoke_service/stylish/04_icon.svg"
                    alt=""
                  />
                  <span
                    className="text"
                  >
                    <b>あとは3週間<br className="sp"/>待つだけで…</b>
                    <br />
                    全国のカラオケ店で<br />歌える!
                  </span>
                </li>
              </ul>
            </div>
          </section>
        </div>
        
        <section className="c-voice c-require">
          <h2 className="c-title">
            <span className="c-title__en js-title">REQUIREMENTS</span>
            <span className="c-title__jp js-title">用意するもの</span>
          </h2>
          <div className="inner fadein2">
            <div className="require__list">
              <div className="require__item">
              <img src="/img/karaoke_service/stylish/icon_movie.svg" alt="" />
              <p className="require__title">歌入り音源<br /><span className="small">または</span><br />歌入り映像</p>
              </div>
              <div className="require__item">
              <img src="/img/karaoke_service/stylish/icon_text.svg" alt="" />
              <p className="require__title text__center">歌詞</p>
              </div>
            </div>
            <p className="require__text">
              <span className="require__body">この2つがあればOK！</span>
            </p>
          </div>
        </section>

        <div className="c-kv__header bg_gray_p2">
          <span>\ 印税も受け取れる！/</span>
          <a href="#c-form" className="c-bt_bk bt_kv cv_bt">今すぐ申し込む</a>
        </div>
        <section className="c-question">
          <h2 className="c-title">
            <span className="c-title__en js-title">Q&A</span>
            <span className="c-title__jp js-title">よくある質問</span>
          </h2>
          <div className="inner">
            <ul className="c-qa fade_list">
              <li className="c-qa__item">
                <h3 className="c-qa__title">どんな曲でも入れられますか？</h3>
                <p className="c-qa__text">はい、あなたの曲であれば配信できます。ただし公序良俗に反するものや権利侵害のあるものはNGです。</p>
              </li>
              <li className="c-qa__item">
                <h3 className="c-qa__title">有名アーティストと同じようにリモコンで検索できますか？</h3>
                <p className="c-qa__text">もちろんです！歌手名検索、曲名検索どちらも表示されます。</p>
              </li>
              <li className="c-qa__item">
                <h3 className="c-qa__title">歌なし音源の提出は不要ですか？</h3>
                <p className="c-qa__text">お持ちであればご提出いただきますが、なくても問題ありません。歌なし音源がない場合、AIによりボーカルを除去して使用します。</p>
                <audio className="audioPlayer" src="/mp3/vocal_less.mp3"></audio>
                <div className="player_controls">
                <img className="toggleButton" src="/img/karaoke_service/play.svg" alt="再生"></img>
                <span>ボーカル除去のサンプル<br className="sp"/>（除去前〜除去後）</span>
                </div>
              </li>
              <li className="c-qa__item">
                <h3 className="c-qa__title">お店で歌われるとき、どんな映像が流れますか？</h3>
                <p className="c-qa__text">ミュージックビデオなどの映像を提出していただいた場合はそれが流れます。そうでない場合は一般的なカラオケ用映像が流れます。</p>
              </li>
              <li className="c-qa__item">
                <h3 className="c-qa__title">どこで歌えるようになりますか？</h3>
                <p className="c-qa__text">全国約4,800店舗のJOYSOUND設置店で歌うことができます。一部対象外の店舗もありますので詳しくは<a href='https://help.frekul.com/1551/' target="_blank">こちら</a>をご確認ください。</p>
              </li>
            </ul>
            <div className="c-button">
              <a href="https://help.frekul.com/artist/karaoke/" target="_blank" rel="noreferrer">
                その他の質問
                <span />
              </a>
            </div>
          </div>
        </section>

        <section className="c-voice">
          <h2 className="c-title">
            <span className="c-title__en js-title">VOICE</span>
            <span className="c-title__jp js-title">利用者の声</span>
          </h2>
          <div className="inner fadein2">
            <ul className="voice__list">
              <li className="voice__item">
                <div className="voice__thumb">
                  <img src="/img/karaoke_service/stylish/voice_01.png" alt="" />
                  <span className="voice__name">
                    シンガー M様
                    <br />
                    2023年3月配信
                  </span>
                </div>
                <p className="voice__text">
                  ファンの方に「やっとカラオケで歌えて楽しい」との声を頂きました。データ提出もオンライン完結でスムーズでした。
                </p>
              </li>
              <li className="voice__item">
                <div className="voice__thumb">
                  <img src="/img/karaoke_service/stylish/voice_02.png" alt="" />
                  <span className="voice__name">
                    バンドメンバー R様
                    <br />
                    2023年4月配信
                  </span>
                </div>
                <p className="voice__text">
                  バンドの格が上がった気になれるのが、自己満足ですが、モチベーション上がります。2万円以内で配信、しかも半永久的なのは安い。
                </p>
              </li>
              <li className="voice__item">
                <div className="voice__thumb">
                  <img src="/img/karaoke_service/stylish/voice_03.png" alt="" />
                  <span className="voice__name">
                    シンガーソングライター
                    <br />
                    Y様 2023年7月配信
                  </span>
                </div>
                <p className="voice__text">
                  飲み会でカラオケに行った際に歌った。結構評判がよく、歌っていて気持ちよかった。どの機種に登録されるかや反映されるまでの期間がわかりやすかった。
                </p>
              </li>
              <li className="voice__item">
                <div className="voice__thumb">
                  <img src="/img/karaoke_service/stylish/voice_04.png" alt="" />
                  <span className="voice__name">
                    シンガーソングライター
                    <br />
                    T様 2024年3月配信
                  </span>
                </div>
                <p className="voice__text">
                カラオケ配信サービスを実際使わせていただきましたが、価格にも手が出しやすい上に完成度の高い物を作成していただきありがとうございました！
                </p>
              </li>
            </ul>
          </div>
        </section>

        <section className="c-form" id="c-form">
          <h2 className="c-title">
            <span className="c-title__en-white js-title">ORDER</span>
            <span className="c-title__jp-white js-title">お申し込み</span>
          </h2>
          <div className="inner">
            <div className="royalty form page">
              <div className="inner">
                <div className="prices fadein2">
                  <p className="prices__title">配信手数料</p>
                  <p className="prices__body">
                    <span className="prices__body_small">1曲 /</span>
                    <span className="prices__body_big">{CurrencyUtility.format(priceInfo.basicAmountWithoutTax)}</span>
                    <span className="prices__body_small">円</span>
                  </p>
                  <div className="prices__taxin">{`${CurrencyUtility.format(priceInfo.basicAmount)}円（税込）`}</div>
                  <p className="prices__info">管理費 : 永年無料</p>
                </div>

                {children}

                <div className="notes fadein3">
                  <h3>注意事項</h3>
                  <ul>
                    <li>・あなたが著作者かつ原盤権者である曲、もしくは著作者および原盤権者から許諾を得た曲のみ申し込み頂けます。</li>
                    <li>・原則的にお申込み後の内容変更はお受けできません。配信内容についても明らかな瑕疵がない限り修正はできません。</li>
                    <li>・お申込みにはFrekulアーティスト登録（無料）が必須です。</li>
                    <li>・ガイドメロディのON/OFF、及び採点の機能は使用できません。もしガイドメロディを入れたい場合は歌なし音源に含めておいてください。</li>
                    <li>
                      ・配信後は原則的に無期限でお楽しみいただけますが、関係各社の環境や方針等の変化により配信が停止になる可能性もございます。
                      その際返金などはできません。
                    </li>
                    <li>・対象機種であっても店舗の環境（インターネット回線等）や方針により、配信されない店舗がございます。</li>
                    <li>・システム上、Frekul.com内や配信先のWEBサイトにて映像や曲が視聴可能な状態になる場合がございます。</li>
                    <li>
                      ・JOYSOUND（ジョイサウンド）への配信は、株式会社エクシングが提供する「うたスキミュージックポスト」の投稿作業を代行する形でのご提供となります。
                      ご自身で投稿する場合は
                      <a href="https://musicpost.joysound.com/top" target="_blank" rel="noreferrer">こちら</a>
                      をご覧ください。
                    </li>
                    <li>
                      ・リクエスト型のサービスではないのでインディーズ・メジャー問わず配信が可能ですが、
                      広告、宣伝に相当する曲や映像については、配信開始前に株式会社エクシングへ確認いたします。
                    </li>
                    <li>
                      ・利用規約は
                      <a href="/terms/#karaoke" target="_blank">こちら</a>
                      からご確認下さい。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="c-question c-bottom">
            <div className="c-button">
              <a href="/" target="_blank" className="add_color">
                Frekulトップへ
                <span />
              </a>
            </div>
          </div>
        </section>
        <a href="https://joysound-challenge.frekul.com/" className="side_banner" target="_blank"><img src="/img/karaoke_service/stylish/jsc_banner.svg" alt="ファンの力で配信" /></a>

      </article>
    </>
  );
}
